// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductReviews_container__3_Pit","review":"ProductReviews_review__3pWBN","image":"ProductReviews_image__187JY"};